module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider2Pre-ce71b1cf.jpeg";